export function buildUrl(href, id, paramName = "id") {
    if (!id) {
        return href;
    }
    return href + "?" + paramName + "=" + id;
}
